/* Depura sections: sliders, tabs, video controls (written for the Depura US store) */
(function () {
  'use strict';

  function initSlider(root) {
    if (root.dataset.dReady) return;
    root.dataset.dReady = '1';
    var track = root.querySelector('.d-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = root.querySelector('.d-dots');
    var prev = root.querySelector('.d-arrow--prev');
    var next = root.querySelector('.d-arrow--next');
    // Loop infinito vero: copie delle slide prima e dopo, a fine scorrimento si salta in silenzio sulla copia centrale
    var N = slides.length;
    var inf = root.dataset.loop === 'true' && N > 1 && track.scrollWidth > track.clientWidth + 2;
    if (inf) {
      var mk = function (s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-d-clone', ''); return c; };
      slides.forEach(function (s) { track.appendChild(mk(s)); });
      slides.slice().reverse().forEach(function (s) { track.insertBefore(mk(s), track.firstChild); });
    }
    function jump(left) {
      track.style.scrollBehavior = 'auto'; track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      track.offsetHeight;
      track.style.scrollSnapType = ''; track.style.scrollBehavior = '';
    }
    function recenter() {
      if (!inf) return;
      var pos = Math.round(track.scrollLeft / Math.max(step(), 1));
      if (pos < N) jump(track.scrollLeft + N * step());
      else if (pos >= 2 * N) jump(track.scrollLeft - N * step());
    }

    function step() {
      var s = slides[0];
      if (!s) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return s.getBoundingClientRect().width + gap;
    }
    function current() {
      var c = Math.round(track.scrollLeft / Math.max(step(), 1));
      return inf ? ((c % N) + N) % N : c;
    }
    function pages() {
      if (inf) return N;
      var visible = Math.max(1, Math.round(track.clientWidth / Math.max(step(), 1)));
      return Math.max(1, slides.length - visible + 1);
    }
    function render() {
      var n = pages();
      var c = Math.min(current(), n - 1);
      if (dots) {
        if (dots.children.length !== n) {
          dots.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Slide ' + (i + 1));
            (function (idx) {
              b.addEventListener('click', function () { var to = (inf ? N : 0) + idx; if (inf) { var at = Math.round(track.scrollLeft / Math.max(step(), 1)); if (to - at > N / 2) to -= N; else if (at - to > N / 2) to += N; } track.scrollTo({ left: to * step(), behavior: 'smooth' }); });
            })(i);
            dots.appendChild(b);
          }
        }
        Array.prototype.forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === c ? 'true' : 'false'); });
        dots.style.display = n > 1 && track.scrollWidth > track.clientWidth + 2 ? '' : 'none';
      }
      if (root.classList.contains('d-pd-rev')) {
        var cur = track.children[Math.round(track.scrollLeft / Math.max(step(), 1))];
        var card = cur && cur.firstElementChild;
        if (card) track.style.height = card.offsetHeight + 'px';
      }
      var scrollable = inf || track.scrollWidth > track.clientWidth + 2;
      if (prev) { prev.style.display = scrollable ? '' : 'none'; prev.disabled = track.scrollLeft <= 2 && root.dataset.loop !== 'true'; }
      if (next) { next.style.display = scrollable ? '' : 'none'; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2 && root.dataset.loop !== 'true'; }
    }
    function go(dir) {
      if (inf) { recenter(); return track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      var atStart = track.scrollLeft <= 2;
      if (root.dataset.loop === 'true' && dir > 0 && atEnd) return track.scrollTo({ left: 0, behavior: 'smooth' });
      if (root.dataset.loop === 'true' && dir < 0 && atStart) return track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { recenter(); render(); }, 120); }, { passive: true });
    window.addEventListener('resize', function () { if (inf) jump((N + current()) * step()); render(); });
    if (root.classList.contains('d-pd-rev')) {
      if (window.ResizeObserver) { var ro = new ResizeObserver(function () { render(); }); Array.prototype.forEach.call(track.children, function (sl) { if (sl.firstElementChild) ro.observe(sl.firstElementChild); }); }
      window.addEventListener('load', render);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
    }
    if (inf) jump(N * step());
    render();

    var speed = parseInt(root.dataset.dAutoplay || '0', 10);
    if (speed > 0) {
      var paused = false;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () { if (!paused && document.visibilityState === 'visible') { var keep = root.dataset.loop; root.dataset.loop = 'true'; go(1); root.dataset.loop = keep; } }, speed * 1000);
    }
  }

  function initTabs(root) {
    if (root.dataset.dReady) return;
    root.dataset.dReady = '1';
    var btns = root.querySelectorAll('[data-d-tab]');
    var panels = root.querySelectorAll('[data-d-panel]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-d-tab');
        Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        Array.prototype.forEach.call(panels, function (p) {
          var on = p.getAttribute('data-d-panel') === id;
          p.hidden = !on;
          var v = p.querySelector('[data-autoplay] video');
          if (v) { if (on) { v.play().catch(function () {}); } else { v.pause(); } }
        });
      });
    });
  }

  function initVideo(box) {
    if (box.dataset.dReady) return;
    box.dataset.dReady = '1';
    var v = box.querySelector('video');
    if (!v) return;
    var play = box.querySelector('.d-play');
    var sound = box.querySelector('.d-sound');
    var auto = box.hasAttribute('data-autoplay');
    if (auto) {
      v.muted = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { v.play().then(function () { box.classList.add('is-playing'); }).catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0.35 }).observe(v);
      }
    }
    function toggle() {
      if (v.paused) {
        document.querySelectorAll('.d-media video').forEach(function (o) { if (o !== v && !o.closest('[data-autoplay]')) o.pause(); });
        v.play().catch(function () {});
      } else { v.pause(); }
    }
    if (play) play.addEventListener('click', function () { if (auto && v.muted && !v.paused) { v.muted = false; if (sound) sound.classList.add('is-on'); return; } toggle(); });
    v.addEventListener('click', toggle);
    v.addEventListener('play', function () { box.classList.add('is-playing'); });
    v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
    if (sound) sound.addEventListener('click', function (e) {
      e.stopPropagation();
      v.muted = !v.muted;
      sound.classList.toggle('is-on', !v.muted);
      if (v.paused) v.play().catch(function () {});
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-d-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-d-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-d-video]').forEach(initVideo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
